import { exists } from '@/helpers/utilities';

let ScrollAnimations = (() => {
    class ScrollAnimations {
        constructor(node) {
            this.node = node;

            this.nodeExists = exists(this.node);
            if (!this.nodeExists) return;

            this.hasPrepped = false;
            this.hasAnimated = false;
        }

        prepStaggerFadeIn(parts) {
            [...parts].map((part) => {
                if (part.dataset.animatable == 'false') return;
                part.classList.add(`js-is-ready`);
            });

            this.hasPrepped = true;
        }

        doStaggerFadeIn() {
            let parts = this.node.children;

            if (!parts.length) return;

            //prep animation
            if (!this.hasPrepped) return this.prepStaggerFadeIn(parts);

            let reverse = this.node.dataset.direction == 'reverse';
            let delay = this.node.dataset.delay ? parseInt(this.node.dataset.delay) : 100;

            if (reverse) {
                parts = [...parts].reverse();
            }

            [...parts].map((part, index) => {
                let animDelay = (index + 1) * delay;

                setTimeout(() => {
                    requestAnimationFrame(() => { 
                        part.classList.add('js-is-active');
                    });
                }, animDelay);
            });

            this.hasAnimated = true;
        }

        getAnimation() {
            let animMethod = this.node.dataset.animate;

            let lookup = {
                'stagger-fade-in': this.doStaggerFadeIn.bind(this),
            };

            if (!animMethod in lookup) return;

            return lookup[animMethod];
        }

        doAnimation(method) {
            if (!method) return;

            method();
        }

        onVisible() {
            let animation = this.getAnimation();
            this.doAnimation(animation);
        }

        setEventBindings() {
            this.node.addEventListener('enteredView', this.onVisible.bind(this));
        }

        init() {
            if (!this.nodeExists) return;

            if (this.node.dataset.start) {
                let animation = this.getAnimation();
                this.doAnimation(animation);

                this.setEventBindings();
            } else {
                setTimeout(() => {
                    //tiny timeout waits for Intersection.js to run
                    //blocks errant animation on page reload when element is already visible
                    if (this.node.classList.contains('js-is-active')) return;
                    let animation = this.getAnimation();
                    this.doAnimation(animation);

                    this.setEventBindings();
                }, 100);
            }
        }
    }

    return {
        init({ selector }) {
            let nodeList = document.querySelectorAll(selector);
            if (!nodeList.length) return;

            return [...nodeList].map((node) => {
                let module = new ScrollAnimations(node);

                module.init();

                return module;
            });
        },
    };
})();

export default Object.create(ScrollAnimations);
